import * as R from 'ramda';

const {enums} = sn;

export const enumValuesToCssClasses = R.pipe(
    R.values,
    R.reduce((accum, item) => R.assoc(item, item.replace(/_/g, '-'), accum), {})
);

/**
 * @export
 * @param {string} type
 * @return {*}
 */
export function convertCampaignType(type) {
    if (
        type === enums.CampaignDisplayType.INSTAGRAM_IMAGE ||
        type === enums.CampaignDisplayType.INSTAGRAM_VIDEO
    ) {
        return enums.CampaignType.INSTAGRAM;
    } else if (type === enums.CampaignDisplayType.YOUTUBE_VIDEO) {
        return enums.CampaignType.YOUTUBE;
    } else if (type === enums.CampaignDisplayType.SNAPCHAT_VIDEO) {
        return enums.CampaignType.SNAPCHAT;
    } else if (type === enums.CampaignDisplayType.TWITTER_IMAGE) {
        return enums.CampaignType.TWITTER;
    }
    // input was not a member of CampaignDisplayType, should be a normal CampaignType, so just return it
    return type;
}



// WEBPACK FOOTER //
// ./common/enum_helper.js